import React from 'react'
import { useElementItemShallowSelector } from '../ElementItemStore'
import { useShallowSelector } from '../Workspace2Store'

/**
 * Hook to handle resetting element values after bulk operations
 * This helps prevent the "Not Used" label from appearing after bulk-add
 *
 * @returns {Function} resetElementAfterBulkOperation - Function to reset element state
 */
export const useElementResetAfterBulkOperation = () => {
    const {
        elementItemValue,
        setElementItemValue,
    } = useElementItemShallowSelector((state) => ({
        elementItemValue: state.elementItemValue,
        setElementItemValue: state.setElementItemValue,
    }))

    const { setIsTreeLoading } = useShallowSelector((state) => ({
        setIsTreeLoading: state.actions.setIsTreeLoading,
    }))

    const resetElementAfterBulkOperation = React.useCallback(() => {
        // Reset element values and set tree loading for non-ASSEMBLY types
        if (elementItemValue?.elementType !== 'ASSEMBLY') {
            setElementItemValue({
                ...elementItemValue,
                elementId: '',
                elementType: '',
                baseElementId: '',
            })
            setIsTreeLoading(true)
        }
    }, [elementItemValue, setElementItemValue, setIsTreeLoading])

    return resetElementAfterBulkOperation
}
